import { Component, OnInit } from '@angular/core';
import { UserResource } from 'app/models/UserResource';
import { UtilsService } from 'app/services/utils.service';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'vbn-forgot-password-confirm',
  templateUrl: './forgot-password-confirm.component.html',
  styleUrls: ['./forgot-password-confirm.component.scss']
})
export class ForgotPasswordConfirmComponent implements OnInit {
  userResource: UserResource
  errorMessage: string
  params: any
  email: any
  dataForRecover = { email: null };

  constructor( private service: UtilsService, private route: ActivatedRoute) {
    this.userResource = new UserResource();
  }

  ngOnInit() {
    this.params = this.route.params.forEach((params: Params) => {
      this.email = JSON.parse(atob(params['email'])).userEmail
    })
    this.registerConfirm(this.userResource);
  }

  registerConfirm(user) {
    this.userResource.email = this.email;
    this.service.add("/admin/user/resetPasswordConfirmed",user)
      .subscribe(
      response => {
        this.userResource = response;
      },
      error => this.errorMessage = <any>error);
  }


}
